'use strict';

const _=require('pulsar-utils/dist-es6/_');
const d3=require('d3');
const TimeSeries=require('pulsar-dashboard-core/dist-es6/utilities/timeSeries');
const BaseControllerBackedDirective=require('../../../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');let

TimelineScheduleDirective=class TimelineScheduleDirective extends BaseControllerBackedDirective{
get objectBindings(){
return[
'displayTimeZone',
'timezoneDescription',
'now',
'timeOfLastScheduleUpdate',
'timeOfLastHosStatus',
'invalidDataWarning',
'predictedWorkday',
'forecastDutyInterval',
'estimatesAsOfTime',
'timezone',
'dailySchedules',
'personalSchedule',
'fatigueThreshold',
'dutyFormatter',
'tripFormatter',
'flightFormatter',
'sleepFormatter',
'sleepPromotingFormatter',
'personalStatistics',
'multiViewParent'];

}

get templateUrl(){
return'/templates/features/personalSchedule/components/timelineSchedule/timelineScheduleView';
}

get controller(){
return TimelineScheduleDirectiveController;
}};let


TimelineScheduleDirectiveController=class TimelineScheduleDirectiveController{
constructor($scope,$element,$timeout,displaySettingsService,timeFormattingService){

this._$scope=$scope;
this._$timeout=$timeout;
this._displaySettingsService=displaySettingsService;
this._timeFormattingService=timeFormattingService;
this._element=$element[0];

const{fatigue,sleep,queryInterval}=this.personalSchedule;
this._fatiguePoints=TimeSeries.assignWhenIntersectingOrOutside(fatigue,sleep,{notRendered:!0},queryInterval);

if(_.exists(this.multiViewParent)){
this._$scope.$watch('controller.personalSchedule',(newSchedule,oldSchedule)=>{
if(newSchedule.queryInterval.equals(oldSchedule.queryInterval)){
return;
}

$timeout(()=>this.multiViewParent.reloadCurrentView());
});
}

this._$scope.$on('resize::resize',()=>this._onDimensionsChanged());

this._onDimensionsChanged();
}

get timeFormattingService(){
return this._timeFormattingService;
}

get use24HourTimeline(){
return this._timeFormattingService.safeUse24HourTimelineSetting;
}

get fatiguePoints(){
return this._fatiguePoints;
}

get dailyDetailColumnsContainer(){
return this._dailyDetailColumnsContainer||(this._dailyDetailColumnsContainer=angular.element(this._element).find('.schedule-daily-detail-columns')[0]);
}

get detailsLabelColumn(){
return this._detailsLabelColumn||(this._detailsLabelColumn=angular.element(this._element).find('.schedule-row-titles-column')[0]);
}

set dailySummaryColumnWidth(newWidth){
this._displaySettingsService.renderCache.columnWidthForTimelineScheduleGraph=newWidth;
}

get dailySummaryColumnWidth(){
return this._displaySettingsService.renderCache.columnWidthForTimelineScheduleGraph;
}

get _shiftDailySummaryColumnsForReport(){
return!1;
}

_onDimensionsChanged(newDimensions,oldDimensions){
const containerWidth=this.dailyDetailColumnsContainer.offsetWidth-this.detailsLabelColumn.offsetWidth;
const timeScale=d3.time.scale().
domain([this.personalSchedule.queryInterval.start,this.personalSchedule.queryInterval.end]).
rangeRound([0,containerWidth]);

const days=this.personalSchedule.queryInterval.getSpanningIntervals('days',1,this.timezone);

const boxWidths=days.slice(0,-1).map((ti,i)=>timeScale(days[i+1].start)-timeScale(ti.start));
const finalBoxWidth=containerWidth-boxWidths.reduce((sum,val)=>sum+=val);
const boxLeftOffset=this.detailsLabelColumn.offsetWidth+(this._shiftDailySummaryColumnsForReport?-0.5:0);
const boxLeftPositions=days.map((ti,i)=>timeScale(ti.start)+boxLeftOffset);

this._$scope.$evalAsync(()=>{
this.boxWidths=boxWidths.concat(finalBoxWidth);
this.boxLeftPositions=boxLeftPositions;
});
}};


module.exports=TimelineScheduleDirective;
module.exports.TimelineScheduleDirectiveController=TimelineScheduleDirectiveController;
//# sourceMappingURL=timelineScheduleDirective.js.map
